import { render, staticRenderFns } from "./WorkReport.vue?vue&type=template&id=06f851c0&scoped=true&"
import script from "./WorkReport.vue?vue&type=script&lang=js&"
export * from "./WorkReport.vue?vue&type=script&lang=js&"
import style0 from "./WorkReport.vue?vue&type=style&index=0&id=06f851c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f851c0",
  null
  
)

export default component.exports